<!-- 列表公用的显示文案 -->
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    props: {
        currentInfo: {
            require: true,
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        //这里存放数据
        return {
            templateList: []
        };
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created () {
        this.initTemplateList()
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        initTemplateList () {
            const { comName, projectName, fullAddress, agentComName, acceptConsortiumBiddingName, remark, bidRequire } = this.currentInfo
            // 添加第一行特殊字段
            let { labelOne, timeOne, label, time } = this.timeInfo(this.currentInfo)
            let rowOne = [
                {
                    span: 12,
                    label: labelOne,
                    content: timeOne
                },
                {
                    span: 12,
                    label: label,
                    content: time
                }
            ]
            // 添加固定的最后一行
            let laseInfo = this.createTimeInfo(this.currentInfo)
            let lastRow = [
                {
                    span: 12,
                    label: '采购单位',
                    content: comName
                },
                {
                    span: 12,
                    label: laseInfo.label,
                    content: laseInfo.time,
                    contentStyle: { color: '#969696' }
                }
            ]
            // 三行动态展示的数据
            let dynamicOne = [
                {
                    span: 12,
                    label: '项目名称',
                    content: projectName
                },
                {
                    span: 12,
                    label: '项目地址',
                    content: fullAddress
                }
            ]
            let dynamicTwo = [
                {
                    span: 12,
                    label: '代理单位',
                    content: agentComName
                },
                {
                    span: 12,
                    label: '是否接受联合体投标',
                    content: acceptConsortiumBiddingName
                }
            ]
            let dynamicThree = [
                {
                    span: 24,
                    label: '招标概括',
                    content: remark
                },
                {
                    span: 24,
                    label: '投标人要求',
                    content: bidRequire
                }
            ]

            this.templateList = [ rowOne ]
            if (this.showCurrentRow(this.currentInfo, 3)) {
                this.templateList.push(dynamicOne)
            }
            if (this.showCurrentRow(this.currentInfo, 2)) {
                this.templateList.push(dynamicTwo)
            }
            if (this.showCurrentRow(this.currentInfo, 1)) {
                this.templateList.push(dynamicThree)
                // 如果清单没有数据的话要单独添加一个线条
                let dashedObj = {
                    class: 'dashedLine'
                }
                this.templateList.push(dashedObj)
            }
            this.templateList.push(lastRow)
        },
        renderRow (createElement, rowList) {
            return createElement('el-row', {},
                rowList.map(item => {
                    return this.renderElCol(createElement, item)
                })
            )
        },
        renderElCol (createElement, info) {
            let self = this
            return createElement('el-col',
                {
                    class: {
                        'ellipsis': true,
                        'footer-item': true
                    },
                    style: {
                        ...info.contentStyle
                    },
                    props: {
                        span: info.span
                    }
                },
                [
                    createElement('span', {}, `${info.label}：`),
                    info.content || self.getDefaultCopy(self.currentInfo)
                ]
            )
        },
        renderDashed (createElement, info) {
            let classObj = {}
            classObj[info.class] = true
            return createElement('div', { class: classObj }, [])
        }
    },
    render (createElement) {
        return createElement('div',
            {
                class: {
                    'footer': true
                }
            },
            this.templateList.map(item => {
                let currentType = Object.prototype.toString.call(item)
                if (currentType == '[object Object]') {
                    return this.renderDashed(createElement, item)
                } else if (currentType == '[object Array]') {
                    return this.renderRow(createElement, item)
                }
            })
        )
    }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.ellipsis {
  // 文本强制不换行
  white-space: nowrap;
  // 溢出显示省略号
  text-overflow: ellipsis;
  // 溢出的部分隐藏
  overflow: hidden;
}
.footer {
  padding: 0px 10px;
  box-sizing: border-box;
  padding-top: 20px;
}
.footer-item {
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
  > span {
    color: #666666;
  }
}
.dashedLine {
  width: 100%;
  border-top: 1px dashed #E4E7ED;
  margin-bottom: 16px;
}
</style>